import { Injectable } from '@angular/core';

@Injectable()
export class DocumentoCategoria
{
  public id: number = 0;
  public nombre: string = '';
  public estado: boolean = true;

  constructor() 
  { 
  }

  limpiarVariables()
  {
    this.id = 0;
    this.nombre = '';
    this.estado = true;
  }
}
